<div>
	<li class="c-list__item focus-inwards-dark" [attr.data-test-id]="'aufgabe-root '+ (aufgabe | testIdFromResource)"
	    [ngClass]="{ 'c-list__item--active': (isSelected | async) === true }">
		<a class="c-list__link" data-test-id="aufgabe-button"
		   [routerLink]="['/verfahren', verfahrenId | async, { outlets: { aufgabe: aufgabeId } }]"
		   (click)="setAufgabe()"
		   [elementFocus]="(isSelected | async) === true">
			@if ((isSelected | async)) {
				<div class="visually-hidden">selektierte Aufgabe</div>
			}
			<div class="c-row c-row--header">
				<span class="c-row__item c-row__item--header" data-test-id="typ">{{ aufgabe | labelByAufgabe }}</span>
				<span class="c-row__item c-row__item--secondary"
				      data-test-id="status">{{ aufgabe.status | enumToLabel: aufgabeStatusLabel }}</span>
				<span class="visually-hidden" role="alert">{{ audioAlert | async }}</span>
			</div>

			@if (hasZertifikatBody) {
				<schir-int-client-aufgabe-zertifikat-body data-test-id="aufgabe-zertifikat-body"
				                                          [aufgabe]="aufgabe"/>
			}
			@if (hasZertifikatsauszugBody) {
				<schir-int-client-aufgabe-zertifikatsauszug-body data-test-id="aufgabe-zertifikatsauszug-body"
				                                                 [aufgabe]="aufgabe"/>
			}
			@if (hasVersandBody) {
				<schir-int-client-aufgabe-versand-body data-test-id="aufgabe-versand-body"
				                                       [aufgabe]="aufgabe"/>
			}
			@if (isRegisterabschrift) {
				<schir-int-client-aufgabe-abschrift-body data-test-id="aufgabe-abschrift-body"
				                                         [aufgabe]="aufgabe"/>
			}
			@if (isEintragungsMitteilung) {
				<schir-int-client-aufgabe-mitteilung-body data-test-id="aufgabe-mitteilung-body"
			                                          [register]="register"
			                                              [aufgabe]="aufgabe"/>
			}
			@if (isWiedervorlage) {
				<schir-int-client-aufgabe-wiedervorlage-body data-test-id="aufgabe-wiedervorlage-body"
				                                             [aufgabe]="aufgabe"/>
			}
			@if (isRechnungsstellung) {
				<schir-int-client-aufgabe-rechnungsstellung-body data-test-id="aufgabe-rechnungsstellung-body"
				                                                 [aufgabe]="aufgabe"/>
			}
			@if (aufgabe.typ === aufgabenTyp.HEIMATHAFENVERLEGUNG || aufgabe.typ === aufgabenTyp.HEIMATORTVERLEGUNG) {
				<schir-int-client-aufgabe-heimatverlegung [aufgabe]="aufgabe"/>
			}
			@if (aufgabe.typ == aufgabenTyp.ALTES_ZERTIFIKAT || aufgabe.typ == aufgabenTyp.ALTER_SCHIFFSBRIEF) {
				<div class="c-row">
				<span data-test-id="altes-zertifikat-text">{{ staticTaetigkeitLabel[aufgabe.typ] }}</span>
			</div>
			}
			@if (aufgabe.typ == aufgabenTyp.ALTER_AUSZUG) {
				<div class="c-row">
				<span data-test-id="alter-auszug-text">{{ staticTaetigkeitLabel[aufgabe.typ] }}</span>
			</div>
			}
			@if (vorlage | async; as _vorlage) {
				<div class="c-row">
				<span>Vorlage: <span data-test-id="vorlage">{{ _vorlage.name }}</span></span>
			</div>
			}
			<div class="c-row c-row--secondary">
				<span class="c-row__item c-row__item--multiline" data-test-id="notiz">{{ aufgabe.notiz }}</span>
			</div>
			@if (!(isSelected | async)) {
				<i class="material-icons c-list__icon" aria-hidden="true" alt="Pfeil rechts">arrow_right</i>
			}
		</a>

		<div class="c-button-bar c-button-bar--overlay increase-z-index">
			<schir-int-client-korrespondenz-button data-test-id="korrespondenz-button" [aufgabe]="aufgabe"
			                                       (openKorrespondenz)="openKorrespondenzInAufgaben()"/>

			@if ((aufgabe | hasResourceLink: linkRel.MARK_AS_FREIGEGEBEN)) {
				<schir-int-client-button-round toolTip="Aufgabe freigeben" data-test-id="aufgabe-freigegeben-button"
			                               materialIcon="check_box_outline_blank"
			                               (click)="markAsFreigegeben()"
			                                   cssClass="focus-inwards-dark schir-midi-button"/>
			}
			@if ((aufgabe | hasResourceLink: linkRel.MARK_AS_ERLEDIGT)) {
				<schir-int-client-button-round toolTip="Aufgabe als erledigt markieren"
			                               data-test-id="aufgabe-erledigt-button" materialIcon="check"
			                                   (click)="markAsErledigt()" cssClass="focus-inwards-dark schir-midi-button"/>
			}
			@if ((aufgabe | hasResourceLink: linkRel.EDIT)) {
				<schir-int-client-button-round toolTip="Aufgabe bearbeiten"
			                               popup="dialog"
			                               data-test-id="aufgabe-bearbeiten-button" materialIcon="edit"
			                               (click)="editAufgabe()"
			                                   cssClass="focus-inwards-dark schir-midi-button"/>
			}
			@if ((aufgabe | hasResourceLink: linkRel.DELETE)) {
				<schir-int-client-button-round toolTip="Aufgabe löschen"
			                               data-test-id="aufgabe-delete-button" materialIcon="delete" (click)="delete()"
			                                   cssClass="focus-inwards-dark schir-midi-button"/>
			}

			@if (aufgabe | hasResourceLink: linkRel.KORRESPONDENZ_VORLAGE) {

				@if (korrespondenzVorlage | async; as _korrespondenzVorlage) {
					<schir-int-client-korrespondenz-vorlage-buttons [korrespondenzVorlage]="korrespondenzVorlage | async"
						(upload)="uploadKorrespondenzVorlage($event, _korrespondenzVorlage.resource)"
						                                            (delete)="deleteKorrespondenzVorlage(_korrespondenzVorlage.resource)"/>
				}

			}
		</div>
	</li>
</div>
